import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function UpTrendIcon({ className }: Props) {
  const { t } = useLingui()

  return (
    <svg
      data-testid="up-trend-icon"
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Trend / Up">
        <title>{t`Up Trend Icon`}</title>
        <path id="Polygon 1" d="M6 4L9 8H3L6 4Z" fill="currentColor" />
      </g>
    </svg>
  )
}
